import { component as defineComponent } from 'flightjs';

var UserAuthentication = function() {
    this.attributes({
        endpoint: '/accounts/xhr/login',
    });

    this.after('initialize', function() {
        this.on(document, 'uiUserAuthenticationRequested', this.sendAuthenticationRequest);
    });

    this.sendAuthenticationRequest = function(e, data) {
        var xhr = $.ajax({
            url: this.attr.endpoint,
            method: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json',
        });

        xhr.done(
            function(res) {
                this.trigger('dataUserAuthenticationSuccess');
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.trigger('dataUserAuthenticationFailure');
            }.bind(this)
        );
    };
};

export default defineComponent(UserAuthentication);



// WEBPACK FOOTER //
// ./src/web/js/launch/data/user-authentication.js